import type { ScribeSuggestionMarker } from '../form-element/scribe-suggestion-marker.model';

export class Widget {
  public id: string = 'uid' + Math.random().toString(36).substring(2);
  public x: number;
  public y: number;
  public name: string;
  public title: string;
  public properties: any;
  public versions: [];
  public comments?: any[];
  public tags?: string[];
  public isScribeSuggested?: ScribeSuggestionMarker;
  constructor(data: any = {}) {
    this.id = this.id; // IMPORTANT: KEEP ID ALWAYS UNIQUE
    this.name = data.name;
    this.title = data.title || void 0;
    this.x = data.x || 0;
    this.y = data.y || 0;
    this.properties = data.properties || {};
    this.versions = data.versions || [1, 2];
    this.isScribeSuggested = data.isScribeSuggested;
  }

  public isRequired() {
    return this.properties?.required?.value;
  }
}
